// ======
import Vue from 'vue'
import App from './App.vue'
import store from './store/store.js'
// 
// imports Views
import Home from '@/views/Home.vue';
import Meny from '@/views/Meny.vue';
import About from '@/views/About.vue';
import Contact from '@/views/Contact.vue';
import Cart from '@/views/Cart.vue';
import Profile from '@/views/Profile.vue';
import Activemobile from '@/views/Activemobile.vue';
import Activecode from '@/views/Activecode.vue';
import Login from '@/views/Login';
import SignUp from '@/views/Signup';
import ForgetPass from '@/views/ForgetPass';
import RestorePass from '@/views/RestorePass';
import notFound from '@/views/notFound';
// tilpase Components 
import pizza_til from '@/components/meny/tilpase/pizza_til';
import kebab_til from '@/components/meny/tilpase/kebab_til';
import other_til from '@/components/meny/tilpase/other_til';
import other_comp_til from '@/components/meny/tilpase/other_comp_til';
import multi_product_til from '@/components/meny/tilpase/multi_product_til';
import half_half_til from '@/components/meny/tilpase/half_half_til';
import entrees_til from '@/components/meny/tilpase/entrees_til';
import burger_til from '@/components/meny/tilpase/burger_til';
// profile blocks
import userprofile from '@/components/profile/profile_block/user_profile';
import orderprofile from '@/components/profile/profile_block/order_profile';
import addressprofile from '@/components/profile/profile_block/address_profile';
import mobileprofile from '@/components/profile/profile_block/mobile_profile';
import passwordprofile from '@/components/profile/profile_block/password_profile';
import discountprofile from '@/components/profile/profile_block/discount_profile';
import deleteprofile from '@/components/profile/profile_block/delete_profile';
// entrees cart
import Entreescart from '@/components/cart/entrees_cart';
import doneOrder from '@/components/cart/done_order';
import doneOrdervipss from '@/components/cart/done_order_vipps';
import errorOrdervipss from '@/components/cart/error_vipps';
import wattingOrdervipss from '@/components/cart/watting_vipps';

// google map
import * as VueGoogleMaps from 'vue2-google-maps';
import Geocoder from "@pderas/vue2-geocoder";
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBpEQ5SSS0hRHRRWDAfmQILGp_82SDqYx8',
    libraries: 'places',
  }
});

Vue.use(Geocoder, {
  defaultCountryCode: null, // e.g. 'CA'
  defaultLanguage:    'no', // e.g. 'en'
  defaultMode:       'lat-lng', // or 'lat-lng'
  googleMapsApiKey:   'AIzaSyBpEQ5SSS0hRHRRWDAfmQILGp_82SDqYx8'
});

import VCreditCard from 'v-credit-card';
import 'v-credit-card/dist/VCreditCard.css';

Vue.component('v-credit-card', VCreditCard);

// bootstrap and Uikit
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import uk from 'uikit'
import 'uikit/dist/css/uikit.min.css';
import 'uikit/dist/js/uikit.min.js'
import $ from 'jquery'
Vue.mixin({
  data: function () {
    return {
      get uk () {
        return uk
      },
    }
  },
  methods:{
    animaion_count(total){
      $('.total_side').each(function() {

        $(this).attr('counter', 0).animate({
            counter: total
        },
         {
            duration: 1000,

            easing: 'swing',

            step: function(total) {

            $(this).text(Math.ceil(total));
            }
        }
        
        );
        });
    }
  }
});
import './scss/main.scss';
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
Vue.use(Buefy);
// end Bootstrap
// import Vue Axios 
document.cookie = "SameSite";
import axios from 'axios';
   //axios.defaults.baseURL = "https://lorenskogrestaurant.24order.com/api/v1";
   //axios.defaults.baseURL = "https://smile3.24order.com/api/v1";
 axios.defaults.baseURL = "https://admin.smile3.no/api/v1";
axios.interceptors.request.use(
  config => {
    config.headers['Cache-Control'] = "no-cache",
    config.headers['content-type'] = "application/vnd.api+json",
    config.headers['Access-Control-Max-Age'] = 290304000
      return config
  },
  error => {
      Promise.reject(error)
  }
)
// tel init
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
Vue.use(VueTelInput, {
  mode: 'international',
  showSearchBox: true
});
// end

// import Vue Router
import VueRouter from 'vue-router';
Vue.use(VueRouter);
const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    document.querySelector('body').scrollIntoView({ behavior: 'instant' });
},
routes: [
  { path: '/', component: Home },
  { path: '/Home', component: Home, name: "Home" },
  // {
  //   path: '/Meny', component: Meny,
  //   beforeEnter: (to, from, next) => {
  //     if (store.getters['auth/authenticated']) {
  //       if (store.getters['auth/user'].is_vaild == 0) {
  //         next({
  //           name: 'ActiveMobile'
  //         });
  //       } else {
  //         next();
  //       }
  //     } else {
  //       next();
  //     }
  //   }
  // }
  {
    path: '/meny/:name?', name:'Meny', component: Meny,
    beforeEnter: (to, from, next) => {
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next({
            name: 'ActiveMobile'
          });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  }
  ,
  {
    path: '/om-oss', component: About,
    beforeEnter: (to, from, next) => {
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next({
            name: 'ActiveMobile'
          });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  },
  {
    path: '/kontakt-oss', component: Contact,
    beforeEnter: (to, from, next) => {
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next({
            name: 'ActiveMobile'
          });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  },
  {
    path: '/Login', component: Login, name: 'Login', beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        router.push({
          name: 'Home',
        });
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      next();
    }
  },
  {
    path: '/forget-password', component: ForgetPass, name: 'ForgetPass', beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        router.push({
          name: 'Home',
        });
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      next();
    }
  },
  {
    path: '/restore-password', component: RestorePass, name: 'RestorePass', beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        router.push({
          name: 'Home',
        });
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      next();
    }
  },
  {
    path: '/Signup', component: SignUp, beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        router.push({
          name: 'Home',
        });
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      next();
    }
  },
  {
    path: '/Cart', component: Cart, beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next('/ActiveMobile');
        } else {
          next();
        }
      } else {
        next('/Login');
      }
    },
  },
  {
    path: '/Entrees-cart', component: Entreescart, beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next('/ActiveMobile');
        } else {
          next();
        }
      } else {
        next('/Login');
      }
    },
  },
  {
    path: '/done-order', component: doneOrder, beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next('/ActiveMobile');
        } else {
          next();
        }
      } else {
        next('/Login');
      }
    },
  }
  ,
  {
    path: '/done-order-vipps/:ordercode', component: doneOrdervipss, beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next('/ActiveMobile');
        } else {
          next();
        }
      } else {
        next('/Login');
      }
    },
  },
    {
    path: '/error-vipps', component: errorOrdervipss, beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next('/ActiveMobile');
        } else {
          next();
        }
      } else {
        next('/Login');
      }
    },
  },
  {
    path: '/payment-process/:ordercode', component: wattingOrdervipss, beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next('/ActiveMobile');
        } else {
          next();
        }
      } else {
        next('/Login');
      }
    },
  },
  {
    path: '/Profile/user', component: Profile, name: 'Profile',

    beforeEnter: (to, from, next) => {
      // check in go to pofile has valid token and has user info
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next({
            name: 'ActiveMobile'
          });
        } else {
          next();
        }
      } else {
        next({
          name: 'Login'
        });
      }
    },
    children: [
      {
          path: '/Profile/user',
          name: 'user',
          component: userprofile
      },
      {
        path: '/Profile/order',
        name: 'order',
        component: orderprofile
    },
    {
      path: '/Profile/address',
      name: 'address',
      component: addressprofile
  },
  {
    path: '/Profile/mobile',
    name: 'mobile',
    component: mobileprofile
},
{
  path: '/Profile/password',
  name: 'password',
  component: passwordprofile
},
{
path: '/Profile/coupon',
name: 'discountprofile',
component: discountprofile
},
{
  path: '/Profile/deactivate-account',
  name: 'deleteprofile',
  component: deleteprofile
  },
  ]

  },
  {
    path: '/ActiveMobile', name: 'ActiveMobile', component: Activemobile,

    beforeEnter: (to, from, next) => {
      if (store.getters['auth/user'].is_vaild == 1) {
        next({
          name: 'Home'
        });
      } else (store.getters['auth/user'].is_vaild == 0)
      {
        next();
      }
    }
  },
  {
    path: '/ActiveCode', name: 'ActiveCode', component: Activecode,

    beforeEnter: (to, from, next) => {
      if (store.getters['auth/user'].is_vaild == 1) {
        next({
          name: 'Home'
        });
      } else (store.getters['auth/user'].is_vaild == 0)
      {
        next();
      }
    }
  },
// compnents Tilpase
  {
    path: '/meny/pizza/:id/:url',
    name: 'pizza_til',
    component: pizza_til,
    beforeEnter: (to, from, next) => {
      // check in go to pofile has valid token and has user info
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next({
            name: 'pizza_til'
          });
        } else {
          next();
        }
      } else {
        next({
          name: 'Login'
        });
      }
    },
  },
  {
    path: '/meny/kebab/:id/:url',
    name: 'kebab_til',
    component: kebab_til,
    beforeEnter: (to, from, next) => {
      // check in go to pofile has valid token and has user info
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next({
            name: 'kebab_til'
          });
        } else {
          next();
        }
      } else {
        next({
          name: 'Login'
        });
      }
    },
  },
  {
    path: '/meny/other/:id/:url',
    name: 'other_til',
    component: other_til,
    beforeEnter: (to, from, next) => {
      // check in go to pofile has valid token and has user info
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next({
            name: 'other_til'
          });
        } else {
          next();
        }
      } else {
        next({
          name: 'Login'
        });
      }
    },
  },
  {
    path: '/meny/other_comp/:id/:url',
    name: 'other_comp_til',
    component: other_comp_til,
    beforeEnter: (to, from, next) => {
      // check in go to pofile has valid token and has user info
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next({
            name: 'other_comp_til'
          });
        } else {
          next();
        }
      } else {
        next({
          name: 'Login'
        });
      }
    },
  }
  ,
  {
    path: '/meny/multi_product/:id/:url',
    name: 'multi_product_til',
    component: multi_product_til,
    beforeEnter: (to, from, next) => {
      // check in go to pofile has valid token and has user info
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next({
            name: 'multi_product_til'
          });
        } else {
          next();
        }
      } else {
        next({
          name: 'Login'
        });
      }
    },
  }
  ,
  {
    path: '/meny/half_half/:id/:url',
    name: 'half_half_til',
    component: half_half_til,
    beforeEnter: (to, from, next) => {
      // check in go to pofile has valid token and has user info
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next({
            name: 'half_half_til'
          });
        } else {
          next();
        }
      } else {
        next({
          name: 'Login'
        });
      }
    },
  }
  ,
  {
    path: '/meny/entrees/:id/:url',
    name: 'entrees_til',
    component: entrees_til,
    beforeEnter: (to, from, next) => {
      // check in go to pofile has valid token and has user info
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next({
            name: 'entrees_til'
          });
        } else {
          next();
        }
      } else {
        next({
          name: 'Login'
        });
      }
    },
  },
  {
    path: '/meny/burger/:id/:url',
    name: 'burger_til',
    component: burger_til,
    beforeEnter: (to, from, next) => {
      // check in go to pofile has valid token and has user info
      if (localStorage.getItem('token') && store.getters['auth/authenticated']) {
        next();
        return;
      }
      store.commit('auth/SET_TOKEN', null);
      store.commit('auth/SET_USER', null);
      router.push({
        name: 'Login',
      });
      if (store.getters['auth/authenticated']) {
        if (store.getters['auth/user'].is_vaild == 0) {
          next({
            name: 'burger_til'
          });
        } else {
          next();
        }
      } else {
        next({
          name: 'Login'
        });
      }
    },
  },
  { path: '/:pathMatch(.*)*', component: notFound },

]
})




Vue.config.productionTip = false;
  store.dispatch('get_setting_api').then(()=>{
  store.dispatch('get_string_api');
  require('@/store/subscribe');
  store.dispatch('auth/attempt', localStorage.getItem('token')).then(() => {
    // console.log('from main js ');
    // on reload app  # refresh # // get cart info if user login 
    // store.dispatch('get_data_cartAction');
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  });
  
});
